import { get } from 'lodash'

export default {
  afterPrepareShow () {
    this.total = this.statistics.reduce((acc, item) => {
      return acc + item.total
    }, 0)
  },
  prepareShow (speciality) {
    speciality.speciality = get(speciality, 'speciality.name', 'Não especificado')

    return speciality
  }
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/abstract-speciality/resources/methods.js